
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-de-privacidade/[[...slug]]",
      function () {
        return require("private-next-pages/politica-de-privacidade/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-de-privacidade/[[...slug]]"])
      });
    }
  